import { render, staticRenderFns } from "./NewTextract.vue?vue&type=template&id=7db61c42&scoped=true&"
import script from "./NewTextract.vue?vue&type=script&lang=js&"
export * from "./NewTextract.vue?vue&type=script&lang=js&"
import style0 from "./NewTextract.vue?vue&type=style&index=0&id=7db61c42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db61c42",
  null
  
)

export default component.exports